<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div style="width: 80%;">
              <div class="form_item">
                <label>投保职业类别</label>
                <div class="right_">
                  <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_" v-model="category" @change="value => clearNumberList()">
                    <a-select-option v-for="(item, index) in occupationNumberList" :key="item.value + 'YLFY' + index" :value="item.occupationKind">{{ item.occupationName }}</a-select-option>
                  </a-select>
                </div>
              </div>
              <div class="policy_none">
                <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
              </div>
              <div class="form_item policy_none">
                <label>投保人数<span style="color:red">(16-65周岁)</span></label>
                <div class="right_">
                  <div v-for="item in occupationNumberList" v-if="category == item.occupationKind" :key="item.occupationKind">
                    <a-input style="width: 300px" type="Number" addon-after="人" :disabled="disabledAll" :min="0" v-model="item.personNum" @change="value => changeData(value, 'TBZYa')"></a-input>
                  </div>
                </div>
              </div>
              <div class="form_item policy_none" v-if="category != '4' && category != '5'">
                <label>投保人数<span style="color:red">(65周岁以上)</span></label>
                <div class="right_">
                  <div v-if="category == item.occupationKinds" v-for="item in cloccupationNumberList" :key="item.occupationKind">
                    <a-input style="width: 300px" type="Number" addon-after="人" :disabled="disabledAll" :min="0" v-model="item.personNum" @change="value => changeData(value, 'TBZYa')"></a-input>
                  </div>
                </div>
              </div>
              <div class="form_item">
                <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
                <div class="right_">
                  <div class="check_item" style="text-align: left;">
                    <a-radio-group name="radioGroup" v-model="countData.stature" @change="value => changeData(value, 'stature')" :default-value="1" :disabled="disabledAll">
                      <a-radio :value="1">涉高</a-radio>
                      <a-radio :value="2">不涉高</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ policy_none">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">主险</p>
        <!-- 意外身故及伤残 -->
        <div class="form_item">
          <label>意外死亡、伤残</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" @change="value => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
              <a-select-option v-for="item in swcjOptions" :key="item.value + 'SWCJ'" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外医疗费用 -->
          <div class="form_item">
            <label class="ant-form-item-required">意外医疗费用补偿</label>
            <div class="right_">
              <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_" v-model="countData.YLFY" @change="value => changeData(value, 'YLFY')">
                <a-select-option v-for="(item, index) in ylfyOptions" :key="item.value + 'YLFY' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 公共交通工具（民航客机)意外身故及伤残 -->
          <div class="form_item">
            <label>公共交通工具（民航客机)意外身故及伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 300px" class="select_" v-model="countData.YCXSCa" @change="value => changeData(value, 'YCXSCa')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'YCXSCa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 公共交通工具（列车、轮船、客运汽车）意外身故及伤残 -->
          <div class="form_item">
            <label>公共交通工具（列车、轮船、客运汽车）意外身故及伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.SHHLa" @change="value => changeData(value, 'SHHLa')">
                <a-select-option v-for="item in SHHLOptions" :key="item.value + 'SHHLa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!--意外每日住院津贴 -->
          <div class="form_item">
            <label>意外每日住院津贴</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.KZSC" @change="value => changeData(value, 'KZSC')">
                <a-select-option v-for="item in KZSCOptions" :key="item.value + 'KZSC'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>

          <!-- 意外医疗费用补偿（扩展社保外医疗，100免100%报） -->
          <div class="form_item">
            <label>意外医疗费用补偿（扩展社保外医疗，100免100%报）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.YLFYBC" @change="value => changeData(value, 'YLFYBC')">
                <a-select-option v-for="item in ylfybcBCOptions" :key="item.value + 'YLFYBC'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list nfl">
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">去投保</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  data() {
    return {
      category: '1', //手选职业类别
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      cloccupationNumberList: DATA.cloccupationNumberList,
      //投保职业及人数
      occupationNumberList: DATA.occupationNumberList,
      premiumSum: 0, //总保费
      HYLXArr: [], //行业类型
      // 测算要提交的数据
      countData: {
        BZQJa: 12, //保障期间?
        stature: 2, //是否涉高
        TBZYa: 0, //投保职业?
        HYLX: '', //行业类型
        SWCJ: 100000, //意外身故及伤残 1
        YLFY: 10000, //意外医疗费用 2
        JTKJ: 0, //意外医疗费用免赔额 3
        ZYJT: 100, //意外医疗费用赔付比例 4
        KZSC: 0, //意外每日住院津贴 5
        YCXSCa: 0, //民航客运飞机意外身故及伤残 6
        SHHLa: 0, //火车意外身故及伤残 7
        YLFYBC: 0, //轮船意外身故及伤残 8
        KYQCYW: 0 //公共汽车意外身故及伤残 9
      },
      //提交data
      data: {
        riskInfos: [
          {
            riskCode: '1119201', //意外身故及伤残
            dutyCode: '1119201',
            amount: 100000,
            premiumAmt: 0,
            riskName: '意外身故、残疾',
            riskAmountDesc: 100000
          }
        ],
        salPolicy: {
          productCode: '', //产品code
          planCode: '', //plancode
          bracket: 12 //保费期限
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          industrycode: '', //行业code
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      },
      creator: '1',
      productCode: '',
      plan: ''
    };
  },
  mixins: [riskinfoMixin],
  computed: {
    ylfybcBCOptions() {
      let ylfybcBCOptions = DATA.ylfybcBCOptions;
      return ylfybcBCOptions;
    },
    // 公共交通工具（民航客机)意外身故及伤残
    oneSCOptions() {
      let baseOptions = this.$lodash.cloneDeep(DATA.baseOptions);
      for (var i = 100000; i <= this.countData.SWCJ * 3; i += 100000) {
        baseOptions.push({
          value: i,
          name: i / 10000 + '万'
        });
      }
      return baseOptions;
    },
    // 公共交通工具（列车、轮船、客运汽车）意外身故及伤残
    SHHLOptions() {
      let baseOptions = this.$lodash.cloneDeep(DATA.baseOptions); //最大值 不超过主险 且与主险相加不超过200w
      let maxValue = 2000000 - this.countData.SWCJ > this.countData.SWCJ ? this.countData.SWCJ : 2000000 - this.countData.SWCJ;
      for (var i = 100000; i <= maxValue; i += 100000) {
        baseOptions.push({
          value: i,
          name: i / 10000 + '万'
        });
      }
      return baseOptions;
    },
    //驾乘私家车意外死亡、伤残
    KYQCYWOptions() {
      let baseOptions = this.$lodash.cloneDeep(DATA.baseOptions); //最大值 不超过主险 且与主险相加不超过100w
      let maxValue = 1000000 - this.countData.SWCJ > this.countData.SWCJ ? this.countData.SWCJ : 1000000 - this.countData.SWCJ;
      for (var i = 100000; i <= maxValue; i += 100000) {
        baseOptions.push({
          value: i,
          name: i / 10000 + '万'
        });
      }
      return baseOptions;
    },
    // 意外每日住院津贴
    KZSCOptions() {
      let KZSCOptions = [
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 50,
          name: '50元/天'
        },
        {
          value: 100,
          name: '100元/天'
        },
        {
          value: 150,
          name: '150元/天'
        },
        {
          value: 200,
          name: '200元/天'
        }
      ];
      return KZSCOptions;
    },
    // 意外身故及伤残
    swcjOptions() {
      let Options = DATA.swcjOptions;

      if (this.category > 3) {
        return Options.filter(item => item.value < 600000);
      }
      return Options;
    },
    // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
    JTKJOptions() {
      let Options = [
        //意外医疗费用免赔额(即保司系统自费药)选择框
        {
          value: 0,
          name: '0'
        },
        {
          value: 100,
          name: '每次事故RMB100'
        },
        {
          value: 200,
          name: '每次事故RMB200'
        }
      ];
      return Options;
    },
    // 意外医疗费用
    ylfyOptions() {
      let option = DATA.ylfyOptions;
      option = option.filter(item => item.value <= this.countData.SWCJ * 0.2);
      return option.filter(item => item.value <= 50000);
    },
    // 计算总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      this.cloccupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: '1119201', //意外身故及伤残
          dutyCode: '1119201',
          amount: this.countData.SWCJ,
          premiumAmt: 0,
          riskName: '意外身故、残疾',
          riskAmountDesc: this.countData.SWCJ
        },
        {
          riskCode: '1119202', //意外医疗费用补偿
          dutyCode: '1119202',
          amount: this.countData.YLFY,
          premiumAmt: 0,
          riskName: '意外医疗费用补偿',
          riskAmountDesc: this.countData.YLFY
        },
        {
          riskCode: '1119204', //公共交通工具（民航客机)意外身故及伤残
          dutyCode: '1119204',
          amount: this.countData.YCXSCa,
          premiumAmt: 0,
          riskName: '公共交通工具（民航客机)意外身故及伤残',
          riskAmountDesc: this.countData.YCXSCa
        },
        {
          riskCode: '111920411', //公共交通工具（民航客机除外)意外身故及伤残
          dutyCode: '1119209',
          amount: this.countData.SHHLa,
          premiumAmt: 0,
          riskName: '公共交通工具（民航客机)意外身故及伤残',
          riskAmountDesc: this.countData.SHHLa
        },
        {
          riskCode: '1119208', //驾乘私家车意外死亡、伤残
          dutyCode: '1119208',
          amount: this.countData.KYQCYW,
          premiumAmt: 0,
          riskName: '驾乘私家车意外死亡、伤残',
          riskAmountDesc: this.countData.KYQCYW
        },
        {
          riskCode: '1119203', //意外每日住院补贴
          dutyCode: '1119203',
          amount: this.countData.KZSC,
          premiumAmt: 0,
          riskName: '意外每日住院补贴',
          riskAmountDesc: this.countData.KZSC
        },
        {
          riskCode: '111920311', //意外医疗费用补偿（社保外医疗）
          dutyCode: '1119210',
          amount: this.countData.YLFYBC,
          premiumAmt: 0,
          riskName: '意外医疗费用补偿（社保外医疗）',
          riskAmountDesc: this.countData.YLFYBC
        }
      ];
      return infos;
    }
  },
  watch: {
    'countData.YLFY'(val) {
      //初始化选项
      if (!val) {
        this.countData.JTKJ = 0;
      }
    }
  },
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      if(data.salInsuredList[0]) {
        this.category = data.salInsuredList[0].occulevel
      }
      //返显险种信息
      let obj = this.$lodash.cloneDeep(this.countData);
      let hycode = data.salPolicyHolder.industrycode;
      if (hycode) {
        this.form.setFieldsValue({
          HYLXArr: [hycode.slice(0, 1), hycode.slice(0, 3), hycode]
        });
        obj.HYLX = hycode;
      }
			// 意外医疗费用补偿
			let YLFYValue = '';
      data.riskInfos.forEach(e => {
        if (e.riskCode == '1119201') this.countData.SWCJ = e.amount;
        if (e.riskCode == '1119202') YLFYValue = e.amount;
        if (e.riskCode == '1119204') this.countData.YCXSCa = e.amount;
        if (e.riskCode == '111920411') this.countData.SHHLa = e.amount;
        if (e.riskCode == '1119208') this.countData.KYQCYW = e.amount;
        if (e.riskCode == '1119203') this.countData.KZSC = e.amount;
        if (e.riskCode == '111920311') this.countData.YLFYBC = e.amount;
      });
			this.countData.YLFY = YLFYValue;
    });
    this.$bus.$on('busStature', data => {
      //返现涉高信息
      this.countData.stature = data - 0;
    });
  },
  methods: {
    clearNumberList() {
      this.cloccupationNumberList = DATA.cloccupationNumberList.map(item => {
        item.personNum = 0
        return item
      });
      //投保职业及人数
      this.occupationNumberList = DATA.occupationNumberList.map(item => {
        item.personNum = 0
        return item
      });
    },
    // 改变试算的数据
    changeData() {
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount > 0), //险种信息
        salPolicy: {
          planCode: this.plan,
          creator: this.creator,
          productCode: this.productCode, //产品code
          bracket: 12, //保费期限
          discountfactor: 1 //折扣系数
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: this.countData.stature //是否高空（2-否，1-是）
        },
        salPolicyExt: {
          isworkheightinvolved: this.countData.stature //是否高空作业
        },
        premiumBaseDtoList: [...this.$lodash.cloneDeep(this.occupationNumberList).filter(item => item.personNum > 0), ...this.$lodash.cloneDeep(this.cloccupationNumberList).filter(item => item.personNum > 0)] //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      this.$bus.$emit('onRiskInfos', arrData);
    },
    //保费试算
    countPremiumSum(e) {
      e.preventDefault();
      let formData = this.$lodash.cloneDeep(this.data);
      this.form.validateFields(err => {
        //保费试算接口
        if (!err) {
          if (this.totalNumber < 3) {
            this.premiumSum = 0;
            this.$message.warning('最低投保人数3人');
            return;
          }
          this.$api.calPremiumEmployer(formData).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = data.totalPremium; //放入保费
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}

.pre-box {
  margin-top: 15px;
}

.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}

.risk_ {
  width: 60%;
}

.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}

.flex_ {
  display: flex;
  flex-wrap: wrap;
}

.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}

.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
</style>
